module.exports = __webpack_public_path__ + "img/package-list-hd-bg.0cf19c0e.png";